import React, { memo } from 'react'
import { ThemeProvider as MThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { ThemeProvider as SThemeProvider } from '@mui/styles'
import PropTypes from 'prop-types'

const AppThemeProvider = ({ children, theme }) => {
	return (
		<StyledEngineProvider injectFirst={!import.meta.env.SSR}>
			<MThemeProvider theme={theme}>
				<SThemeProvider theme={theme}>{children}</SThemeProvider>
			</MThemeProvider>
		</StyledEngineProvider>
	)
}

AppThemeProvider.propTypes = {
	theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	children: PropTypes.node,
}

export default memo(AppThemeProvider)
